import type { ChartType } from '@/components/Chart/types/highcharts';
import type { SymbolKey } from '@/entities/symbol';

export const CHART_HEIGHT = 400;

export interface PreviewChartProps {
  symbols: SymbolKey[];
  type: ChartType;
  from?: string;
}
